const API_METHOD_NAMES = {
  METHOD_GET_PROJECTS: "METHOD_GET_PROJECTS",
  METHOD_POST_PROJECTS: "METHOD_POST_PROJECTS",
  METHOD_GET_PROJECT: "METHOD_GET_PROJECT",
  METHOD_DELETE_PROJECT: "METHOD_DELETE_PROJECT",
  METHOD_DELETE_COLLECTION: "METHOD_DELETE_COLLECTION",

  METHOD_GET_TABLES: "METHOD_GET_TABLES",
  METHOD_POST_TABLES: "METHOD_POST_TABLES",
  METHOD_DELETE_TABLE: "METHOD_DELETE_TABLE",
  METHOD_GET_TABLE: "METHOD_GET_TABLE",

  METHOD_PATCH_PREPROCESSING: "METHOD_PATCH_PREPROCESSING",
  METHOD_GET_PREPROCESSING_RESULT: "METHOD_GET_PREPROCESSING_RESULT",
  
  METHOD_PATCH_ANNOTATION: "METHOD_PATCH_ANNOTATION",
  METHOD_GET_ANNOTATION_RESULT: "METHOD_GET_ANNOTATION_RESULT",

  METHOD_GET_SAVED_ADDITIONAL_CONTENT: "METHOD_GET_SAVED_ADDITIONAL_CONTENT",
  METHOD_PUT_SAVED_ADDITIONAL_CONTENT: "METHOD_PUT_SAVED_ADDITIONAL_CONTENT",

  METHOD_PATCH_CREATE_TABLES_FROM_GOLD_STANDARDS: "METHOD_PATCH_CREATE_TABLES_FROM_GOLD_STANDARD",
  METHOD_GET_GOLD_STANDARDS_TABLES: "METHOD_GET_GOLD_STANDARDS_TABLES",

  METHOD_GET_STATUS: "METHOD_GET_STATUS",
}

const DISPLAYED_ERROR_MESSAGES_BY_METHOD = [
  {
    method: API_METHOD_NAMES.METHOD_GET_PROJECTS,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Projects not found.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_DELETE_PROJECT,
    messages: [
      {
        errorStatusCode: 2003,
        displayMessage: 'It is not possible to delete projects with existing tables.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_DELETE_COLLECTION,
    messages: [
      {
        errorStatusCode: 2003,
        displayMessage: 'It is not possible to delete collections with existing tables.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_POST_PROJECTS,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Project creation impossible for this user.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_GET_PROJECT,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Project not found.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_GET_TABLES,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Tables not found.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_POST_TABLES,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Table creation impossible for this project.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_DELETE_TABLE,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Table not found.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_GET_TABLE,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Table not found.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_PATCH_PREPROCESSING,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Preprocessing impossible for this table.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_GET_PREPROCESSING_RESULT,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Preprocessing result not found.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_PATCH_ANNOTATION,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Annotation impossible for this table.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_GET_ANNOTATION_RESULT,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Annotation result not found.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_PATCH_CREATE_TABLES_FROM_GOLD_STANDARDS,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Table creation impossible for this user and this gold standards.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_GET_GOLD_STANDARDS_TABLES,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Gold standards not found.'
      }
    ]
  },
  {
    method: API_METHOD_NAMES.METHOD_GET_STATUS,
    messages: [
      {
        errorStatusCode: 60,
        displayMessage: 'Status not found.'
      }
    ]
  },
];

const getDisplayMessage = function(methodName, error) {
//  console.log("[getDisplayMessage] error : ", error);
//  console.log("[getDisplayMessage] error.internalErrorCode : ", error.internalErrorCode);
//  console.log("[getDisplayMessage] error.body.internalErrorCode : ", error.body.internalErrorCode);
  let returnedDisplayMessage = undefined;
  let methodDisplayErrorMessage = undefined;
  DISPLAYED_ERROR_MESSAGES_BY_METHOD.map(displayErrorMessage => {
    if (displayErrorMessage.method === methodName) {
      methodDisplayErrorMessage = displayErrorMessage.messages;
    }
  });
  if (methodDisplayErrorMessage) {
    methodDisplayErrorMessage.map(message => {
      if (error !== undefined) {
        if (message.errorStatusCode === error.internalErrorCode) {
          returnedDisplayMessage = message.displayMessage;
        } else if ( (error.body !== undefined) && (message.errorStatusCode === error.body.internalErrorCode) ) {
          returnedDisplayMessage = message.displayMessage;
        }  
      }
    });
  }
  return returnedDisplayMessage;
}

const launchTemporaryDisplayedMessage = function(message) {
  const id = Date.now() + '' + Math.random();
  MessageDisplayerService.store.commit('addDisplayedMessage', { id: id, text:message.text, type: message.type, modalText: message.modalText, maxTime: 5000 });
  setTimeout(() => {
    MessageDisplayerService.store.commit('removeDisplayedMessage', { id: id });
  }, 2500);
}

const removeDisplayedMessage = function(messageId) {
  MessageDisplayerService.store.commit('removeDisplayedMessage', { id: messageId });
}

class MessageDisplayerService {

  static store = undefined;

  constructor() {

  }

  static startServiceUsingStore(givenStore) {
    MessageDisplayerService.store = givenStore;
  }

  static METHOD_NAMES = API_METHOD_NAMES;


  static showSuccessMessage(methodName) {
    // console.log('[DEBUG] [showSuccessMessage] [INCOMING_METHOD_NAME] ', methodName);
    let text = undefined;
    let type = 'OK';
    switch (methodName) {
      case API_METHOD_NAMES.METHOD_GET_PROJECTS :
        text = 'Projects received.';
        break;
      case API_METHOD_NAMES.METHOD_DELETE_PROJECT :
        text = 'Project deleted.';
        break;
      case API_METHOD_NAMES.METHOD_DELETE_COLLECTION :
        text = 'Collection deleted.';
        break;
      case API_METHOD_NAMES.METHOD_POST_PROJECTS :
        text = 'Project created.';
        break;
      case API_METHOD_NAMES.METHOD_GET_PROJECT :
        text = 'Project received.';
        break;

      case API_METHOD_NAMES.METHOD_GET_TABLES :
        text = 'Tables received.';
        break;
      case API_METHOD_NAMES.METHOD_POST_TABLES :
        text = 'Table(s) created.';
        break;
      case API_METHOD_NAMES.METHOD_DELETE_TABLE :
        text = 'Table deleted.';
        break;
      case API_METHOD_NAMES.METHOD_GET_TABLE :
        text = 'Table received.';
        break;
  
      case API_METHOD_NAMES.METHOD_PATCH_PREPROCESSING :
        text = 'Preprocessing launched.';
        break;
      case API_METHOD_NAMES.METHOD_GET_PREPROCESSING_RESULT :
        text = 'Preprocessing result received.';
        break;
 
      case API_METHOD_NAMES.METHOD_PATCH_ANNOTATION :
        text = 'Annotation launched.';
        break;
      case API_METHOD_NAMES.METHOD_GET_ANNOTATION_RESULT :
        text = 'Annotation result received.';
        break;

      case API_METHOD_NAMES.METHOD_GET_SAVED_ADDITIONAL_CONTENT :
        text = 'Saved Annotation Additional Content loaded.';
        break;
      case API_METHOD_NAMES.METHOD_PUT_SAVED_ADDITIONAL_CONTENT :
        text = 'Annotation Additional Content saved.';
        break;
  
      case API_METHOD_NAMES.METHOD_PATCH_CREATE_TABLES_FROM_GOLD_STANDARDS :
        text = 'Table(s) created from gold standards';
        break;
      case API_METHOD_NAMES.METHOD_GET_GOLD_STANDARDS_TABLES :
        text = 'Gold standards received.';
        break;
      
      case API_METHOD_NAMES.METHOD_GET_STATUS :
        text = 'Status OK!';
        break;
    }

    if (!text) {
      // if text has not been defined by switch method
      console.log('[DEBUG] [showSuccessMessage] No text definition for method ' + methodName);
    } else if (text === '') {
      // if no text must been displayed
      console.log('[DEBUG] [showSuccessMessage] No display for method ' + methodName);
    } else {
      // if a text must been displayed
      launchTemporaryDisplayedMessage({ text: text, type: type });
    }
  }

  static showErrorMessage(methodName, error) {
    // console.log('[DEBUG] [showErrorMessage] [INCOMING_METHOD_NAME] ', methodName);
    // console.log('[DEBUG] [showErrorMessage] [INCOMING_ERROR] ', error);
    let errorString = undefined;
    let errorObject = undefined;
    // define errorString and errorObject values from error
    if (error) {
      if (typeof error === 'string') {
        // if error parameter is a string
        try {
          errorObject = JSON.parse(error);
          errorString = error;
        } catch (e) {
          console.log('[DEBUG] [showErrorMessage] Parse error for method ' + methodName + ' and error : ' + error);
        }
      } else {
        // if error parameter is not a string
        try {
          errorString = JSON.stringify(error);
          errorObject = error;
        } catch (e) {
          console.log('[DEBUG] [showErrorMessage] Stringify error for method ' + methodName + ' and error : ', error);
        }
      }
    }

    let text = getDisplayMessage(methodName, errorObject);
    let type = 'ERROR';

    if (!text) {
      // if text has not been defined by getDisplayMessage method
      console.log('[DEBUG] [showErrorMessage] No text definition for method ' + methodName + ' and error : ' + errorString);
      const text = 'Error during ' + methodName;
      const modalText = '[TECHNICAL_ERROR] ' + methodName + ' do not define text for error : ' + errorString;
      let displayMessage = {
          text,
          type,
          modalText
      };
      console.log('[DEBUG] [showErrorMessage] DisplayMessage for method ' + methodName + ' and error : ' + errorString + ' -> ' + JSON.stringify(displayMessage));
      launchTemporaryDisplayedMessage(displayMessage);
    } else if (text === '') {
      // if no text must been displayed
      console.log('[DEBUG] [showErrorMessage] No display for method ' + methodName + ' and error : ' + errorString);
    } else {
      // if a text must been displayed
      let displayMessage = {
          text,
          type
      };
      console.log('[DEBUG] [showErrorMessage] DisplayMessage for method ' + methodName + ' and error : ' + errorString + ' -> ' + JSON.stringify(displayMessage));
      launchTemporaryDisplayedMessage(displayMessage);
    }
  }

  static removeMessage(messageId) {
    // console.log('[DEBUG] [removeMessage] ', messageId);
    removeDisplayedMessage(messageId);
  }

  static showText(text, type = 'INFO') {
    launchTemporaryDisplayedMessage({ text: text, type: type });
  }

}

export default MessageDisplayerService